<template>
  <div id="rechargeB">
    <div id="cardSetUp">
      <div class="packagePanel">
        <h1 class="package-title-ka">
          <div class="u-icon">
            <img src="@/assets/hd/b-g.png" alt="">
          </div>
          <div>
            <div class="recordLoginText">{{ recordLoginText }}</div>
            <div class="recordLoginText1">客户卡号</div>
          </div>
        </h1>
        <h1 class="package-title">选择流量包</h1>
        <div style="display: flex; justify-content: space-between;flex-wrap: wrap;padding:0 13px;">
          <template v-for="item in simData">
            <div class="package p-se2" :key="item.id" :class="{ 'label-defined-active': indexActive == item.id }"
              v-if="simData.length >= 1" @click="changeState(item)" style="position: relative;">
              <div class="package-name">
                <h1 v-if="item.type == 11 || item.type == 16 || item.type == 18">
                  {{ item.packageName ? item.packageName : item.name }}</h1>
                <h1 v-else>{{ item.packageName ? item.packageName : item.name }}</h1>
                <p v-if="(item.type == 17)">
                  有效期：30天有效期 套餐顺延生效，当月如需继续使用 请充值加油包。</p>
                <p v-if="(item.type == 10)">
                  有效期：每个月月底清零，套餐包用完可继续购买加油包使用。</p>

                <p v-if="(item.type == 14)">
                  有效期：每个月27号清零，套餐包可无限叠加使用。</p>
                <p v-if="(item.type == 15)">
                  有效期：每个月27号清零，套餐包用完可继续购买加油包使用。</p>
                <p v-if="(item.type == 3)">
                  有效期：每个月月底清零，再次购买顺延生效，流量用完请购买加油包。</p>

                <p v-if="(item.type == 2)">
                  有效期：每个月月底清零，套餐可无限叠加。</p>
                   <p v-if="(item.type == 1)">
                  有效期：套餐流量月底清零。</p>
                <p v-if="(item.type == 18 || item.type == 11 || item.type == 16 || item.type == 4)">
                  主套餐用完后，请购买此套餐,加油包可无限叠加使用</p>
               <p v-if="(item.type == 20)">
                  套餐每30天含{{item.flowRate/1024}}G流量，一年有效，有效期内流量不够用，请充值加油包。 </p>
                <p v-if="(item.type == 21)">
                  套餐每个月含{{item.flowRate/1024}}G流量，一年有效，有效期内流量不够用，请充值加油包。 </p>
                   <p v-if="(item.type == 25)">
                  套餐每个月含{{item.flowRate/1024}}G流量 每月27号重新算套餐流量，一年有效，有效期内流量不够用，请充值加油包。 </p>
                    <p v-if="(item.type == 26)">
                  套餐每个月含{{item.flowRate/1024}}G流量 每月27号重新算套餐流量，半年有效，有效期内流量不够用，请充值加油包。 </p>
                   <p v-if="(item.type == 24)">
                  套餐每30天含{{item.flowRate/1024}}G流量，半年有效，有效期内流量不够用，请充值加油包。 </p>
                <p v-if="(item.type == 23)">
                  套餐每个月含{{item.flowRate/1024}}G流量，半年有效，有效期内流量不够用，请充值加油包。 </p>
                <p style="color:red">{{ item.remark }}</p>
              </div>
              <div class="package-price">
                <p>￥<span>{{ item.salePriceRmb ? item.salePriceRmb : item.salePrice / 100 }}</span></p>
                <div class="fdaw">原价</div>
              </div>

            </div>
            <div class="package4" :key="item.id" v-if="simData.length >= 14" @click="changeState(item)">
              <span class="label-defined" :class="{ 'label-defined-active': indexActive == item.id }">
                <label v-if="indexActive == item.id">
                  <van-icon name="success" color="#fff" />
                </label>
              </span>
              <div class="package4-name">
                <h1 v-if="item.type == 11 || item.type == 16 || item.type == 18">
                  {{ item.packageName ? item.packageName : item.name }}</h1>
                <h1 v-else>{{ item.packageName ? item.packageName : item.name }}</h1>
                <p v-if="(item.type == 17)">
                  套餐流量30天有效，可跨月使用，有效期内流量不够用，请充值加油包。</p>
                <p v-if="(item.type == 18 || item.type == 11)">
                  主套餐用完后，请购买此套餐,加油包可无限叠加使用</p>
                <p v-if="(item.type == 10)">
                  有效期：每个月月底清零，套餐包用完可继续购买加油包使用。</p>

                <p v-if="(item.type == 14)">
                  有效期：每个月27号清零，套餐包可无限叠加使用。</p>
                <p v-if="(item.type == 15)">
                  有效期：每个月27号清零，套餐包用完可继续购买加油包使用。</p>
                <p v-if="(item.type == 3)">
                  有效期：每个月月底清零，再次购买顺延生效，流量用完请购买加油包。</p>
                <p v-if="(item.type == 1)">
                  有效期：套餐流量月底清零。</p>
                <p v-if="(item.type == 2)">
                  有效期：每个月月底清零，套餐可无限叠加。</p>
                <p v-if="(item.type == 18 || item.type == 11 || item.type == 16 || item.type == 4)">
                  主套餐用完后，请购买此套餐,加油包可无限叠加使用 月底清零。</p>


                <p v-if="(item.type == 20)">
                  套餐每30天含{{item.flowRate/1024}}G流量，一年有效，有效期内流量不够用，请充值加油包。 </p>
                <p v-if="(item.type == 21)">
                  套餐每个月含{{item.flowRate/1024}}G流量，一年有效，有效期内流量不够用，请充值加油包。 </p>
                   <p v-if="(item.type == 25)">
                  套餐每个月含{{item.flowRate/1024}}G流量 每月27号重新算套餐流量，一年有效，有效期内流量不够用，请充值加油包。 </p>
                    <p v-if="(item.type == 26)">
                  套餐每个月含{{item.flowRate/1024}}G流量 每月27号重新算套餐流量，半年有效，有效期内流量不够用，请充值加油包。 </p>
                   <p v-if="(item.type == 24)">
                  套餐每30天含{{item.flowRate/1024}}G流量，半年有效，有效期内流量不够用，请充值加油包。 </p>
                <p v-if="(item.type == 23)">
                  套餐每个月含{{item.flowRate/1024}}G流量，半年有效，有效期内流量不够用，请充值加油包。 </p>
              </div>

              <div class="package4-price">
                <p>￥<span>{{ item.salePriceRmb ? item.salePriceRmb : item.salePrice / 100 }}元</span></p>
                <div class="fdaw">原价</div>
              </div>
            </div>

          </template>
        </div>
        <h1 class="package-title">优惠券</h1>
        <div class="quan" v-if="showjuan">
          <div class="w-zh">优惠</div>
          <div class="z-icon" @click="lintTo"><span v-if="toatl">-￥{{ toatl }}</span></div>
        </div>
        <div class="quan" v-else>
          <div class="w-zh">优惠</div>
          <div class="z-icon">暂无可用优惠卷</div>
        </div>
      </div>
    </div>
    <Checkstand :checkstandStyle="checkstandStyle" :dataToPay="dataToPay" :price="price" :type="type"
      :packageTypeCode="packageTypeCode" :primaryId="primaryId" :secondaryId="secondaryId" />

    <div class="toRecharge">
      <div class="toRecharge-top" v-if="showMonthChoose || isNaturalMonth">
        <van-radio-group v-model="isNextMonth" class="radio-group-defined">
          <div>
            <van-radio name="0" checked-color="#FFA941">本月生效</van-radio>
          </div>
          <div>
            <van-radio name="1" checked-color="#FFA941">次月生效</van-radio>
          </div>
        </van-radio-group>
      </div>

      <p class="detail" v-if="isNaturalMonth">请在有效时间内使用
        <span v-show='this.isNextMonth == 0'>，<span>月底清零。</span></span>
        <span v-show='this.isNextMonth == 1'>，<span>次月月底清零。</span></span>
      </p>

      <div class="toRecharge-bottom" v-if="showjuan">
        <p>金额：<span>{{ money_format(price, 2, '.', ',') - toatl > 0 ? money_format( money_format(price, 2, '.', ',') * 1 - toatl) : 0 }}
            元</span><span v-if="toatl" style="font-size:12px;display:inline-block;padding-left:4px;">优惠
            ¥{{ toatl }}</span></p>
        <div class="toRechargeBtn" @click="toRecharge()">
          <div class="n-btn">订 购</div>
        </div>
      </div>
      <div class="toRecharge-bottom" v-else>
        <p>金额：<span>{{ money_format(price, 2, '.', ',') - 0 > 0 ? money_format(price, 2, '.', ',') - 0 : 0 }}
            元</span><span v-if="toatl" style="font-size:12px;display:inline-block;padding-left:4px;">优惠 ¥ 0</span></p>
        <div class="toRechargeBtn" @click="toRecharge()">
          <div class="n-btn">订 购</div>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
import { wxRequest } from '@/api/user.js'
import { Toast, Dialog } from 'vant';
import Checkstand from "@/components/Checkstand";

export default {
  components: { Checkstand },
  data() {
    return {
      recordLoginText: localStorage.getItem('recordLoginText'),
      indexActive: '',
      simData: [],

      itemInfo: {
        supplierTypeName: '',
        flowRate: '',
        salePriceRmb: ''
      },
      showjuan: false,//是否展示优惠卷
      toatl: 0,
      secondaryId: '',
      primaryId: '',
      isAdmin: '',
      globalIsAdmin: '',
      isNextMonth: '0',
      payType: 1,
      isNaturalMonth: false,
      showCheckstand: false,
      showMonthChoose: false,//判断是否显示本月次月

      //收银台
      checkstandStyle: {
        height: '50%',
        transition: '0.8s !important',
      },
      dataToPay: {},
      price: 0,
      packageTypeCode: 0,
      type: '',
      mobile: '',
      result:{}
    }
  },
  methods: {
    lintTo() {
      this.$router.push({ name: 'coupon' })
    },
    changeState(item) {
      this.indexActive = item.id;
      this.itemInfo = item;
      this.price = item.salePriceRmb ? item.salePriceRmb : item.salePrice / 100;
      this.type = item.type;
      this.packageTypeCode = item.packageTypeCode;

      if (item.isAdmin != null &&
        item.isAdmin != undefined &&
        item.isAdmin == 1) {
        this.isAdmin = item.isAdmin;
      } else {
        this.isAdmin = this.globalIsAdmin;
      }
      if (item.type == 10 || item.type == 17 || item.type == 2|| item.type == 15
      || item.type == 20|| item.type == 21|| item.type == 23|| item.type == 24|| item.type == 25|| item.type == 26) {
        this.showjuan = true;
        if (this.$route.query.total) {
          this.toatl = this.$route.query.total * 1
          this.secondaryId = this.$route.query.secondaryId
          this.primaryId = this.$route.query.primaryId
        }else{
          this.toatl = 0
          if(this.result.subJuan){
            this.toatl = this.result.subJuan.price * 1
            if(this.result.subJuan.types === 1){
              this.secondaryId = this.result.subJuan.id
            }else{
              this.primaryId = this.result.subJuan.id
            }
          }
        }
      } else {
        this.showjuan = false;
        this.toatl = 0;
      }

      this.isNaturalMonth = item.type == 2 || item.type == 10 || item.type == 14 || item.type == 15 ? true : false;
      this.showMonthChoose = item.type == 2 || item.type == 14 || item.type == 15 || item.type == 10 ? true : false;
    },

    toRecharge() {
      var pop = {
        iccid: this.$store.state.iccid,
        pkgId: this.itemInfo.id,
        isAdmin: this.isAdmin,
        // secondaryId:this.secondaryId,
        // primaryId:this.primaryId,
        isNextMonth: this.isNextMonth
      }
      //判断是否是月卡
      if (this.isNaturalMonth) {
        pop.isNextMonth = this.isNextMonth;
      } else {
        pop.isNextMonth = '0';//万能卡
      }
      if (this.tabbar == 1) {
        pop.pkgId = this.itemInfo.id
      } else {
        pop.pkgId = this.itemInfo.id
      }
      wxRequest("sim/activity/timer", pop, "post").then(res => {
        if (res.data.code == 200) {
          Dialog.confirm({
            title: "套餐生效提醒",
            message: "生效时间：" + res.data.data.start + "<br/>到期时间：" + res.data.data.end +
              "<br/>" +
              "<font style='color:red;font-weight:bold;'>请确定套餐生效时间！</font>"
          }).then(() => {

            let self = this;
            //如果是青岛联通，//直接跳去换卡链接
            console.info("self.$store.state.supplierCode", self.$store.state.supplierCode)
            if (self.$store.state.supplierCode == '47D2E3C5A85845F7800DFD52DFB06CE4') {
              this.$router.push({
                path: '/user/userChgCard',
                query: {
                  iccid: self.$store.state.iccid
                }
              });
              return;
            }

            var data = {
              iccid: this.$store.state.iccid,
              soldPackageId: this.itemInfo.id,
              isAdmin: this.isAdmin,
              secondaryId: this.secondaryId,
              primaryId: this.primaryId,
              toatl: this.toatl,
              salePriceRmb: this.itemInfo.salePriceRmb - this.toatl * 1 > 0 ? this.money_format(this.itemInfo.salePriceRmb - this.toatl * 1 ,2, '.', ','): 0,
              mobile: this.mobile
            }
            //判断是否是月卡
            if (this.isNaturalMonth) {
              data.isNextMonth = this.isNextMonth;
            } else {
              data.isNextMonth = '0';//万能卡
            }

            if (this.$store.state.source != false) {
              data.source = this.$store.state.source;
            } else {
              data.source = 'xxgzh';
            }
            this.$store.state.showCheckstand = true;
            this.$store.state.showCheckstandSource = 'flowRecharge';
            this.dataToPay = data;

          })

        } else {
          let self = this;
          //如果是青岛联通，//直接跳去换卡链接
          if (self.$store.state.supplierCode == '47D2E3C5A85845F7800DFD52DFB06CE4') {
            this.$router.push({
              path: '/user/userChgCard',
              query: {
                iccid: self.$store.state.iccid
              }
            });
            return;
          }

          var data = {
            iccid: this.$store.state.iccid,
            soldPackageId: this.itemInfo.id,
            isAdmin: this.isAdmin,
            secondaryId: this.secondaryId,
            primaryId: this.primaryId,
            toatl: this.toatl,
            salePriceRmb: this.itemInfo.salePriceRmb - this.toatl * 1 > 0 ? this.money_format(this.itemInfo.salePriceRmb - this.toatl * 1 ,2, '.', ',') : 0,
            mobile: this.mobile
          }
          //判断是否是月卡
          if (this.isNaturalMonth) {
            data.isNextMonth = this.isNextMonth;
          } else {
            data.isNextMonth = '0';//万能卡
          }

          if (this.$store.state.source != false) {
            data.source = this.$store.state.source;
          } else {
            data.source = 'xxgzh';
          }

          this.$store.state.showCheckstand = true;
          this.$store.state.showCheckstandSource = 'flowRecharge';
          this.dataToPay = data;
        }
      })



    },

    //第n天后
    afterManyDays(manyDays) {
      let startTime = new Date();
      let startDate = new Date(startTime);
      startDate.setDate(startDate.getDate() + manyDays);
      return this.dateFormat('yyyy-MM-dd', startDate);
    },

    // 本月最后一天
    lastDayOfThisMonth() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth();
      return this.dateFormat('yyyy-MM-dd', new Date(year, month + 1, 0));
    },

    //下个月第一天
    firstDayOfNextMonth() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth();
      var day = date.getDate();

      let date2 = new Date(year, month + 1, 1)
      return this.dateFormat('yyyy-MM-dd', new Date(date2));
    },
    // 下个月最后一天
    lastDayOfNextMonth() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth();
      return this.dateFormat('yyyy-MM-dd', new Date(year, month + 2, 0));
    },

    changePayType(type) {
      this.payType = type;
    },
  },
  created() {
    var data = {
      iccid: this.$store.state.iccid
      //iccid:'898604B20421D0287469'
    }
    wxRequest("sim/user/soldPkg/sale", data, "get").then(res => {
      var result = res.data.data;
      this.result = res.data.data;
      if (res.data.code == 200 && result.list.length > 0) {
        let resultArray = [];
        for (let i = 0; i < result.list.length; i++) {
          if (result.list[i].type == 11 || result.list[i].type == 18 || result.list[i].type == 16) {
            resultArray.push(result.list[i]);
          } else {
            resultArray.unshift(result.list[i]);
          }
        }

        this.simData = resultArray;
        this.isAdmin = result.isAdmin;
        this.globalIsAdmin = result.isAdmin;
        this.itemInfo = this.simData[0];
        // console.log('1',this.itemInfo)
        this.indexActive = this.simData[0].id;
        this.isNaturalMonth = this.simData[0].type == 2 || this.simData[0].type == 10 || this.simData[0].type == 15 ? true : false;
        this.showjuan = this.simData[0].type == 2 || this.simData[0].type == 10 || this.simData[0].type == 15 || this.simData[0].type == 17 || this.simData[0].type == 20|| this.simData[0].type == 21|| this.simData[0].type == 23|| this.simData[0].type == 24|| this.simData[0].type == 25|| this.simData[0].type == 26 ? true : false;
        this.price = this.simData[0].salePriceRmb ? this.simData[0].salePriceRmb : this.simData[0].salePrice / 100;
        this.toatl = 0
        this.secondaryId = ''
        this.primaryId = ''
        if (this.$route.query.total) {
          this.toatl = this.$route.query.total * 1
          this.secondaryId = this.$route.query.secondaryId
          this.primaryId = this.$route.query.primaryId
        }else{
          this.toatl = result.subJuan.price * 1
          if(result.subJuan.types === 1){
            this.secondaryId = result.subJuan.id
          }else{
            this.primaryId = result.subJuan.id
          }
        }
      }
    })

    /**每月倒数第6天默认选中次月生效**/
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth();
    var day = date.getDate();

    var date2 = new Date(year, month + 1, 0)
    var endDay = date2.getDate();
    day >= endDay - 8 ? this.isNextMonth = '1' : this.isNextMonth = '0';
  },
  mounted() {
    let param = {
      iccid: this.$store.state.iccid,
      mobile: localStorage.getItem('mobile'),
    }
    wxRequest("sysUser/account/querySysUserAccount", param, "post").then(res => {
      if (res.data.code == 200) {
        this.mobile = res.data.data.mobile;
      }
    });
  },

}
</script>
<style>
#cardSetUp .flowPkg-choose {
  height: 36px;
}

#cardSetUp .flowPkg-choose .van-dropdown-menu__item {
  padding: 0 10px;
}

#cardSetUp .flowPkg-choose .van-dropdown-menu__title {
  display: contents;
}

#cardSetUp .flowPkg-choose .van-dropdown-menu__title .van-ellipsis {
  width: 100%;
}

#cardSetUp .flowPkg-choose .van-dropdown-menu__title::after {
  right: 10px;
}

#cardSetUp .flowPkg-choose .van-dropdown-item__content {
  padding: 0 20px;
}

#cardSetUp .flowPkg-choose .van-dropdown-item__content .van-cell {
  padding-left: 8px;
  padding-right: 8px;
}

#cardSetUp .checkstand-defined-popup .van-field__control {
  font-size: 24px;
}

#cardSetUp .checkstand-defined-popup input::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  font-size: 14px;
}

#cardSetUp .checkstand-defined-popup input::-moz-placeholder {
  /* Firefox 19+ */
  font-size: 14px;
}

#cardSetUp .checkstand-defined-popup input::-ms-input-placeholder {
  /* IE 10+ */
  font-size: 14px;
}

#cardSetUp .checkstand-defined-popup input::-moz-placeholder {
  /* Firefox 18- */
  font-size: 14px;
}

.changePasswordPanel-cardSetUp [class*=van-hairline]::after {
  border-color: #c4cedc;
}
</style>
<style lang="less" scoped>
.quan {
  margin: 12px 13px;
  background: #F6F6F6;
  display: flex;
  align-items: center;
  border-radius: 8px;
  height: 52px;

  div {
    width: 46%;
  }

  .w-zh {
    color: #28292D;
    font-size: 18px;
    padding-left: 20px;
    font-weight: 600;
  }

  .z-icon {
    text-align: right;
    background: url('../../assets/hd/arrow.png')no-repeat 90% center;
    padding-right: 36px;
    color: #DE4160;
    height: 20px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
  }
}

#cardSetUp {
  background: #F4F3F3;

  .cardSetUp-top {
    min-height: 180px;
    padding: 30px 20px 10px 20px;
    margin-bottom: 20px;
    background: #fff;

    p {
      margin-bottom: 10px;
      padding-left: 10px;
      line-height: 36px;
      font-size: 16px;
    }

    h1 {
      margin-bottom: 10px;
      padding-left: 10px;
      font-weight: bold;
    }

    .flowPkg-choose {
      background: #F4F3F3;
    }

  }

  .packagePanel {
    .package-title-ka {
      // width: 100%;
      height: 77px;
      background: url("../../assets/hd/titlebg.png") no-repeat;
      background-size: 100% 100%;
      padding: 0 12px;
      font-size: 18px;
      font-weight: bold;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .u-icon {
        width: 45px;
        height: 45px;

        img {
          height: 100%;
          width: 100%;
        }
      }

      .recordLoginText {
        display: block;
        font-size: 18px;
        margin-left: 8px;
        margin-bottom: 6px;
      }

      .recordLoginText1 {
        display: block;
        font-size: 12px;
        margin-left: 8px;
        font-weight: normal;
      }
    }

    .package-title {
      color: #333;
      font-size: 18px;
      margin-top: 24px;
      margin-bottom: 16px;
      font-weight: bold;
    }

    .p-se {
      background: #E1EDFF;
    }

    .p-se2 {
      background: #EFEFEF;
    }

    .p-se3 {
      background: #FEECE0;
    }

    .package {
      width: 100%;
      display: flex;
      position: relative;
      margin-bottom: 10px;
      border-radius: 11px;



      .package-name {
        flex-grow: 1;
        padding: 12px 0 12px 16px;

        h1 {
          margin: 5px 0;
          color: #28292D;
          font-weight: bold;
          font-size: 18px;
        }

        p {
          margin: 10px 0;
          font-weight: 500;
          color: #63666D;
          width: 200px;
          line-height: 17px;
          font-size: 12px;
        }
      }

      .package-price {
        width: 100px;
        // border: 1px solid #FFA941;
        //margin-right: 12px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        // background: linear-gradient(144deg, #FB674A 1%, #FE9C54 99%);
        position: absolute;
        right: 6px;
        top: -7px;
        height: 95%;
        border-radius: 11px;

        p {
          font-size: 14px;
          font-weight: bold;
          color: #DE4160;

          span {
            font-size: 24px;
            color: #DE4160;
          }
        }

      }

      .package-price.overlay-package {
        border-color: #07c160;
        background: #07c160;
      }

    }

    .label-defined {
      display: block;
      border-width: 14px 18px 14px 18px;
      border-style: solid;
      border-color: transparent;
      position: absolute;

      label {
        position: absolute;
        left: -14px;
        top: -12px;
        background: transparent;
      }
    }

    .label-defined-active {
      // border-color: red transparent transparent red;
      background: #EEF2FE;
      border: 1px solid #436FD5;
    }

    .package4 {
      width: 169px;
      height: 147px;
      background: #E1EDFF;
      border-radius: 4px;
      margin-bottom: 8px;

      .package4-name {
        flex-grow: 1;
        padding: 13px 13px 0;

        h1 {
          margin: 5px 0;
          color: #0D7FC6;
          font-weight: bold;
          font-size: 18px;
        }

        p {
          margin: 10px 0;
          font-weight: 500;
          color: #63666D;
          line-height: 17px;
          font-size: 12px;
        }
      }

      .package4-price {
        display: flex;
        margin-left: 11px;
        align-items: center;
        width: 110px;
        height: 28px;
        // background: linear-gradient(144deg, #FB674A 1%, #FE9C54 99%);
        border-radius: 14px;
        justify-content: center;

        p {
          font-size: 14px;
          font-weight: bold;
          color: #DE4160;

          span {
            font-size: 24px;
          }
        }
      }
    }
  }

  .fdaw {
    font-size: 14px;
    color: #DE4160;
    text-align: right;
    margin-top: 6px;
    width: 60%;
  }

  .toRecharge {
    position: fixed;
    width: 100%;
    bottom: 0;
    font-size: 16px;

    .toRecharge-top {
      display: flex;
      background: #fff;

      .radio-group-defined {
        display: flex;
        padding-left: 20px;
        justify-content: center;
        align-items: center;
        height: 40px;

        div {
          height: 20px;
          margin-right: 15px;
        }
      }

    }

    .detail {
      color: #fff;
      background: #5B6C97;
      padding-left: 20px;
      padding-bottom: 5px;
    }

    .toRecharge-bottom {
      display: flex;

      p {
        padding-right: 15px;
        color: #333333;
        background: #fff;
        text-align: right;
        padding-left: 14px;
        line-height: 45px;

        span {
          color: #DE4160;
          font-size: 24px;
        }
      }

      .toRechargeBtn {
        padding: 0 30px;
        display: inline-block;
        line-height: 40px;
        height: 40px;
        color: #fff;
        margin: 6px 0;
        border-radius: 22px;
        text-align: center;
        width: 16%;
        min-width: 120px;
        background: #408AF7;
      }
    }

  }

  .cardSetUp-middle {
    padding: 0 15px 10px;

    .cardSetUp-middle-title {
      font-weight: bold;
      font-size: 18px;
      //line-height: 30px;
      margin-bottom: 10px;
    }

    .package-choose {
      padding: 16px 8px 9px;
      background: #fff;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      text-align: center;
    }

    .package-choose-item {
      padding: 0;
      height: 81px;
      flex-basis: 30%;
      margin-bottom: 9px;
      border: 1px solid #C9C9C9;
      border-radius: 8px;

      .package-choose-item-price {
        font-weight: bold;
        height: 52px;
        line-height: 52px;
        font-size: 24px;
        margin: 0;

        span {
          font-size: 14px;
        }
      }

      .packahe-choose-item-desc {
        height: 27px;
        line-height: 27px;
        color: #FB694A;
        font-weight: bold;
        background: #FFE3E1;
        border-radius: 0px 0px 8px 8px;
      }
    }

    .package-item-action-desc {
      background: #FFFFFF !important;
      color: #FB694A !important;
    }

    .package-item-action {
      border: 1px solid #FE9C54 !important;
      color: #fff !important;
      background: linear-gradient(144deg, #FB674A 1%, #FE9C54 99%) !important;
    }

    .package-choose-item-defined {
      h1 {
        font-size: 20px;
        line-height: 60px;
      }
    }
  }


  .cardSetUp-action-btn {
    padding: 20px 20px 10px 20px;
    color: #fff;

    button {
      width: 100%;
      line-height: 36px;
      font-size: 16px;
      font-weight: bold;
      border-radius: 25px;
      background: #0D7FC6;
      border: none;
    }
  }

  .cardSetUp-tip {
    padding: 10px 20px 10px 20px;

    p {
      span {
        color: #FB684A;
      }

      color: #666666;
      font-size: 13px;
      line-height: 20px;
    }
  }

  .cardSetUp-tip1 {
    padding: 0px 0px 0px 20px;

    p {
      span {
        color: #FFA941;
      }

      line-height: 20px;
    }
  }

  .checkstand-defined {
    .checkstand-defined-popup {
      position: fixed;
      background-color: #fff;
      z-index: 92;
      width: 80%;
      min-height: 30%;
      top: 30%;
      left: 10%;
      border-radius: 15px;

      .input-defined {
        padding: 15px 0 0 30px;
        border-bottom: 1px solid #ccc;
        display: flex;

        span {
          display: inline-block;
          color: #3a3a3a;
          font-size: 16px;
          line-height: 47px;
        }
      }

      .btn-defined {
        padding: 30px 15px 20px 15px;

        button {

          background: rgba(255, 169, 65, 1);
          border: 0px solid rgba(255, 255, 255, 1);
          width: 100%;
          height: 36px;
          color: #fff;
          border-radius: 5px;
        }
      }


    }

    .close-icon {
      position: absolute;
      right: 5px;
      top: -15px;
    }

    h1 {
      margin-top: 5px;
      font-size: 14px;
      line-height: 40px;
      text-align: center;
    }
  }
}


.changePasswordPanel-cardSetUp {
  padding: 10px;

  .icon-cross {
    position: absolute;
    right: 10px;
    font-size: 16px;
  }

  p {
    margin: 10px 16px 0 16px;
    line-height: 30px;
  }

  .confirmChangePassword {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;

    .confirmChangePasswordBtn {
      width: 80px;
      margin: 0 15px;
    }
  }


}

#rechargeB {
  background: #F5F5F5;
  height: 100%;

  .header {
    padding: 10px 16px;
    background: #fff;
    margin-bottom: 10px;

    div {
      color: #999;
      font-size: 15px;
      line-height: 30px;
    }

    div:nth-child(2) {
      color: #333;
      font-size: 18px;
    }
  }


  .packagePanel {
    // padding: 5px 16px;
    background: #fff;
    padding-bottom: 120px;

    .package-title {
      padding: 10px 13px;
      color: #333;
      font-weight: bold;
    }

    .package {
      display: flex;
      position: relative;
      margin-bottom: 20px;

      .label-defined {
        display: block;
        border-width: 14px 18px 14px 18px;
        border-style: solid;
        border-color: transparent;
        position: absolute;

        label {
          position: absolute;
          left: -14px;
          top: -12px;
          background: transparent;
        }
      }

      .label-defined-active {
        // border-color: red transparent transparent red;
        background: #EEF2FE;
        border: 1px solid #436FD5;
      }




      .package-price {
        width: 80px;
        // border: 1px solid #FFA941;
        margin-right: 12px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        // background: linear-gradient(144deg, #FB674A 1%, #FE9C54 99%);
        border-radius: 5px;

        p {
          font-size: 14px;
          font-weight: bold;
          color: #DE4160;

          span {
            font-size: 24px;
            color: #DE4160;
          }
        }

      }

      .package-price.overlay-package {
        border-color: #07c160;
        background: #07c160;
      }

    }

  }




  .toRecharge {
    position: fixed;
    width: 100%;
    bottom: 0;
    font-size: 16px;
    background: #fff;

    .toRecharge-top {
      display: flex;
      background: #fff;

      .radio-group-defined {
        display: flex;
        padding-left: 20px;
        justify-content: center;
        align-items: center;
        height: 40px;

        div {
          height: 20px;
          margin-right: 15px;
        }
      }

    }

    .detail {
      color: #fff;
      background: #5B6C97;
      padding-left: 20px;
      font-size: 12px;
      line-height: 22px;
    }

    .toRecharge-bottom {
      display: flex;

      p {
        padding-right: 15px;
        color: #333333;
        background: #fff;
        line-height: 45px;
        padding-left: 14px;
        width: 65%;

        span {
          color: #DE4160;
          font-size: 24px
        }
      }

      .toRechargeBtn {
        // padding: 0 30px;
        display: inline-block;
        line-height: 40px;
        height: 40px;
        color: #fff;
        margin: 6px 0;
        width: 35%;

        .n-btn {
          border-radius: 22px;
          text-align: center;
          background: #408AF7;
          width: 90%;
          margin: 0 auto;
        }
      }
    }

  }
}
</style>
